import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";
import tw from "twin.macro";

import ContactCard from "./contact-card";
import Hero from "../hero";
import Tabs from "../tabs";
import AppLink from "../app-link";

const Corrections = tw.div`container mx-auto my-4`;
const CardGrid = tw.div`container mx-auto grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-4 my-4 items-start flex-1`;
const FormContainer = tw.div`sticky top-0 bg-gray-50 border-b border-gray-200 py-2`;
const Form = tw.div`container mx-auto`;
const Label = tw.label`sr-only`;
const Input = tw.input`placeholder-gray-700 w-full border border-gray-200 p-2 hocus:border-blue-700 hocus:shadow rounded`;

const ContactList = ({ contacts }) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "contact-banner.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const [filter, setFilter] = useState("");

  const onFilterChange = e => {
    setFilter(e.target.value.toLowerCase());
  };
  const tabs = [
    { label: "Organizational Contacts", active: false, to: "/contact" },
    { label: "Contact Directory", active: true, to: "/contacts-directory" }
  ];

  return (
    <>
      <Hero imgQuery={data.file.childImageSharp.fluid}>Contact Directory</Hero>
      <div tw="bg-gray-100">
        <div tw="container mx-auto">
          <Tabs tabs={tabs} />
        </div>
      </div>
      <FormContainer>
        <Form>
          <Label htmlFor="filter">Filter Contacts</Label>
          <Input
            id="filter"
            placeholder="Search (name or affiliation)"
            onChange={onFilterChange}
          />
        </Form>
      </FormContainer>
      <Corrections>
        <p>
          This is a contact directory for CP-CTNet members. Report corrections
          to{" "}
          <AppLink href="mailto:Admin_CP-CTNet@frontierscience.org">
            Admin_CP-CTNet@frontierscience.org
          </AppLink>
        </p>
      </Corrections>
      <CardGrid>
        {contacts
            .filter(contact => {
              return Object.values(contact).some(v => typeof v === 'string' && v?.toLowerCase()?.includes(filter))
            })
          .map(({ id, first_name, last_name, affiliation, email, phone }) => (
            <ContactCard
              id={id}
              key={id}
              title={`${first_name || ''} ${last_name || ''}`}
              details={[affiliation, email, phone]}
            />
          ))}
      </CardGrid>
    </>
  );
};

ContactList.propTypes = {
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      id: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      affiliation: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string
    })
  )
};

export default ContactList;
